export default "__VITE_ASSET__88fc0f06__"